<template>
  <div class="conditioncon-1" ref="condition" v-show="isShowtypeScreen">
    <div class="overflowbox">
      <div class="overflowinner" ref="overflowinner">
        <!-- 地区场馆 -->
        <ul class="clearfix" v-if="areaTypeList && areaTypeList.length > 0" v-for="(item, i) in areaTypeList" :key="'H' + i" :data-code="item.dictCode">
          <li>
            <a href="javascript:void(0);">{{item.dictName}}</a>
          </li>
          <li v-for="(items, j) in item.list" :key="'M'+ j"
              :class="{ selected: j === areaTypeList[i].showFlag }"
              data-type="areaType"
              @click="typeSelect('areaType', item.dictCode, items.dictCode, i, j, items.groupList)">
            <a>{{items.name}}</a>
          </li>
        </ul>
        <ul class="clearfix" v-if="codeTypeList[0].list && codeTypeList[0].list.length > 1" v-for="(item, i) in codeTypeList" :key="'X' + i" :data-code="item.dictCode">
          <li>
            <a href="javascript:void(0);">{{item.dictName}}</a>
          </li>
          <li v-for="(items, j) in item.list" :key="'Y'+ j"
              :class="{ selected: j === codeTypeList[i].showFlag }"
              @click="typeSelect('venueType', items.parentId, items.id, i, j, items.code)">
            <a>{{items.name}}</a>
          </li>
        </ul>
        <!--词典类型/通用 过渡后的-->
        <ul class="clearfix" v-if="dictTypeList && dictTypeList.length > 0" v-for="(item, i) in dictTypeList" :key="'A' + i" :data-code="item.dictCode">
          <li>
            <a href="javascript:void(0);">{{item.dictName}}</a>
          </li>
          <li v-for="(items, j) in item.list" :key="'B'+ j"
              v-if="item.list && item.list.length > 1"
              :data-code="items.dictCode"
              :class="{ selected: j === dictTypeList[i].showFlag }"
              @click="typeSelect('dictType', item.dictCode, items.dictCode, i, j, '')">
            <a>{{items.dictName}}</a>
          </li>
        </ul>
        <!--自定义类型-->
        <div class="clearfix" v-if="customTypeList.length > 0">
          <div v-for="(seriesitems, seriesindex) in customlayerSeriesvalue" :key="seriesindex">
            <ul class="clearfix" v-for="(item, k) in [customTypeList[seriesindex]]" :key="'C'+ k" v-if="seriesitems === 1">
              <li><a href="javascript:void(0);">{{item.name}}</a></li>
              <li v-for="(items, m) in item.children" :key="'D'+ m"
                  data-type="customTypeId"
                  :data-id="items.id"
                  :class="{ selected: m === customTypeList[seriesindex].showFlag }"
                  @click="typeSelect('customTypeId', items.parentId, items.id, seriesindex, m, '')">
                <a>{{items.name}}</a>
              </li>
            </ul>
            <!--自定义类型-->
            <ul class="cascaderbox clearfix" v-if="seriesitems > 1">
              <li>
                <a>{{customTypeList[seriesindex].name}}</a>
                <el-cascader
                  ref="cascdertree"
                  clearable
                  v-model="customtypedefaultArr[seriesindex].defaultval"
                  :props="cascaderprops"
                  :options="customTypeList[seriesindex].children"
                  @change="handleChange(seriesitems, seriesindex)"
                  :append-to-body="false"></el-cascader>
              </li>
            </ul>
          </div>
        </div>
        <!--固定类型-->
        <ul class="clearfix" v-if="fixedTypeList && fixedTypeList.length > 0" v-for="(item, n) in fixedTypeList" :key="'E' + n" :data-code="item.dictCode">
          <li>
            <a href="javascript:void(0);">{{item.name}}</a>
          </li>
          <li v-for="(items, v) in item.children" :key="'F'+ v"
              :data-code="items.dictCode"
              :class="{ selected: v === fixedTypeList[n].showFlag }"
              @click="typeSelect('fixedType', item.fixedtypename, items.code, n, v, item.fixedtypeId)">
            <a>{{items.name}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import typeconfig from '@/components/typescreen/typeconfig'
import { getTypeList } from '@/api/typescreen/index'
import { getarea } from '@/api/userservice/index'
import { funDate } from '@/utils/validate'
export default {
  name: 'index',
  // 模型名称、菜单
  props: ['modelType', 'menuId', 'fixedTypeList'],
  // props: {
  //   modelType: defaultStatus,
  //   menuId: defaultStatus,
  //   fixedTypeList: {
  //     type: Array,
  //     default: () => {
  //       return []
  //     }
  //   }
  // },
  data () {
    return {
      dictTypeList: [],
      customTypeList: [],
      typeParam: {
        'dictParentCode': typeconfig[this.modelType].dictName,
        'menuId': this.menuId
      },
      dictType: {},
      newdictType: {},
      customType: {},
      customTypeArr: [],
      searchType: {},
      currentSelect: 0,
      isShowtypeScreen: true,
      areaTypeList: [],
      codeTypeList: [{
        dictCode: 'codes',
        dictName: '场馆类型',
        list: [],
        showFlag: 0
      }],
      allcodeTypeList: [],
      urlsearchflag: false,
      customlayerSeriesvalue: [],
      cascaderprops: {
        value: 'id',
        label: 'name'
      },
      customtypedefaultArr: [],
      alllayerSeries: []
    }
  },
  mounted () {
    this.getTypeList()
    if (this.modelType === 'information' || this.modelType === 'appointment' || this.modelType === 'digital' || this.modelType === 'venue') {
      this.getareacodeList()
    }
  },
  methods: {
    getareacodeList () {
      getarea(this.$cookie.get('museumCode')).then(res => {
        if (res.data.rel) {
          if (res.data.data.length > 0) {
            res.data.data.unshift({'id': '', 'name': '全部'})
            this.areaTypeList.push({
              dictCode: 'codes',
              dictName: '地区类型',
              list: res.data.data,
              showFlag: 0
            })
            this.areaTypeList[0].list.map(item => {
              if (item.groupList !== undefined && item.groupList !== '') {
                let currentFisrtItem = {'id': '', 'name': '全部', 'code': ''}
                let currentAllcode = []
                item.groupList.map(items => {
                  this.allcodeTypeList.push(items)
                  currentAllcode.push(items.code)
                })
                currentFisrtItem.code = currentAllcode.join(',')
                item.groupList.unshift(currentFisrtItem)
              }
            })
            this.allcodeTypeList.unshift({'id': '', 'name': '全部', 'code': ''})
            this.typeSelect('areaType', '', '', 0, 0, this.allcodeTypeList)
          } else {
            this.areaTypeList = []
            this.typeSelect('areaType', '', '', '', -1, '')
          }
        }
      })
    },
    /* 获取菜单层级数 */
    recursion (obj, k, index) {
      this.customlayerSeriesvalue[index] = Math.max(isNaN(this.customlayerSeriesvalue[index]) ? 0 : this.customlayerSeriesvalue[index], k)
      if (obj.children) {
        obj.children.forEach((v, i) => {
          this.recursion(v, k + 1, index)
        })
      }
      return this.customlayerSeriesvalue[index]
    },
    /* 获取筛选条件列表 */
    getTypeList () {
      let _this = this
      getTypeList(this.typeParam).then((res) => {
        if (res.data.rel) {
          this.$emit('typedata', res.data.data)
          /* 通用词典类型格式化 */
          Object.keys(res.data.data.dictType).forEach(item => {
            typeconfig[_this.modelType].dictArr.forEach(dictitem => {
              if (item === dictitem.name) {
                res.data.data.dictType[item].dictName = dictitem.descname
              }
            })
            res.data.data.dictType[item].dictCode = item
            res.data.data.dictType[item].showFlag = 0
            if (res.data.data.dictType[item].list.length > 0) {
              res.data.data.dictType[item].list.unshift({'dictCode': '', 'dictName': '全部'})
              _this.dictTypeList.push(res.data.data.dictType[item])
            }
          })
          _this.customTypeList = res.data.data.customType.map((item, index) => {
            item.showFlag = 0
            item.children.unshift({'name': '全部', 'children': [], 'parentId': item.id, 'id': ''})
            return item
          })
          if (_this.customTypeList.length > 0) {
            _this.customTypeList.forEach((item, index) => {
              _this.customlayerSeriesvalue[index] = _this.recursion(item, 0, index)
            })
            _this.customlayerSeriesvalue.map((item, index) => {
              if (item > 1) {
                _this.customTypeList[index] = _this.formatData([_this.customTypeList[index]])[0]
                let obj = {defaultval: [''], parentId: _this.customTypeList[index].id}
                _this.customtypedefaultArr[index] = obj
                _this.alllayerSeries.push(index)
              }
            })
          }
          _this.$nextTick(() => {
            if (_this.$refs.overflowinner.innerText === '') _this.isShowtypeScreen = false
          })
        }
      })
    },
    // 格式化数据，递归将空的children置为undefined
    formatData (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length === 0) {
          data[i].children = undefined
        } else {
          this.formatData(data[i].children)
        }
      }
      return data
    },
    handleChange (val, index) {
      let currentIndex = index
      this.alllayerSeries.forEach((item, indexs) => {
        if (item === index) currentIndex = indexs
      })
      let allnode = this.$refs.cascdertree[currentIndex].getCheckedNodes()
      this.typeSelect('customTypeId', this.customTypeList[index].id, allnode[0].value, '', '', '')
    },
    /* 条件筛选 */
    typeSelect (type, parentval, val, parentIndex, index, param1) {
      // console.log('type:' + type)
      // console.log('parentval:' + parentval)
      // console.log('val:' + val)
      // console.log('parentIndex:' + parentIndex)
      // 处理地区类型
      if (type === 'areaType') {
        if (this.areaTypeList.length > 0) {
          this.areaTypeList[parentIndex].showFlag = index
        }
        this.codeTypeList[0].list = []
        this.codeTypeList[0].showFlag = 0
        let urlcode = this.$route.query.codes
        if (param1 !== undefined) {
          if (param1.length > 1) {
            if (urlcode !== undefined && urlcode !== '' && this.urlsearchflag === false) {
              this.urlsearchflag = TextTrackCue
              if (urlcode === this.$cookie.get('museumCode')) {
                this.codeTypeList[0].list = this.allcodeTypeList
                this.searchType['codes'] = ''
              } else {
                this.areaTypeList[parentIndex].list.map((items, areaindex) => {
                  if (items.code === urlcode) {
                    this.areaTypeList[parentIndex].showFlag = areaindex
                    this.codeTypeList[0].list = items.groupList
                    return false
                  }
                  if (items.groupList !== undefined && items.groupList !== '') {
                    items.groupList.map((groupitems, groupindex) => {
                      if (groupitems.code === urlcode) {
                        this.areaTypeList[parentIndex].showFlag = areaindex
                        this.codeTypeList[0].showFlag = groupindex
                        this.codeTypeList[0].list = this.areaTypeList[parentIndex].list[areaindex].groupList
                        return false
                      }
                    })
                  }
                })
                this.searchType['codes'] = urlcode
              }
            } else {
              if (index !== 0) {
                this.codeTypeList[0].list = this.areaTypeList[parentIndex].list[index].groupList
                this.searchType['codes'] = param1[0].code
              } else {
                this.codeTypeList[0].list = this.allcodeTypeList
                this.searchType['codes'] = ''
              }
            }
          } else {
            this.searchType['codes'] = param1 === '' ? '' : param1[0].code
          }
        } else {
          if (index !== 0) {
            this.codeTypeList[0].list = this.allcodeTypeList
            this.searchType['codes'] = this.areaTypeList[parentIndex].list[index].code
          } else {
            this.codeTypeList[0].list = this.allcodeTypeList
            this.searchType['codes'] = ''
          }
        }
      }
      if (type === 'venueType') {
        // console.log(this.codeTypeList)
        this.codeTypeList[parentIndex].showFlag = index
        this.searchType['codes'] = param1
      }
      // 处理通用词典类型
      if (type === 'customTypeId') {
        // 选中当前li添加class
        if (parentIndex !== '') this.customTypeList[parentIndex].showFlag = index
        this.forlistnewOBj(this.customType, parentval, val)
        this.customTypeArr = []
        console.log(this.customType)
        Object.keys(this.customType).forEach(item => {
          if (this.customType[item] !== '') this.customTypeArr.push(this.customType[item])
        })
      }
      // 处理
      if (type === 'dictType') {
        // 选中当前li添加class
        this.dictTypeList[parentIndex].showFlag = index
        this.forlistnewOBj(this.dictType, parentval, val)
        typeconfig[this.modelType].dictArr.forEach((item, index) => {
          if (item.name === parentval) item.data = this.dictType[parentval]
          this.newdictType[item.param] = item.data
        })
      }
      // 固定
      if (type === 'fixedType') {
        this.fixedTypeList[parentIndex].showFlag = index
        /* 活动时间类型 */
        if (param1 === 1) {
          if (val === 1) this.searchType[parentval] = funDate(0)
          if (val === 2) this.searchType[parentval] = funDate(0) + ',' + funDate(6)
          if (val === 3) this.searchType[parentval] = funDate(0) + ',' + funDate(29)
          if (val === '') this.searchType[parentval] = ''
        }
        /* 活动状态 */
        if (param1 === 2) {
          this.searchType[parentval] = val
        }
      }
      this.searchType['customTypeId'] = this.customTypeArr.join(',')
      this.searchType = Object.assign(this.newdictType, this.searchType)
      // console.log(this.searchType)
      this.$emit('typeObj', this.searchType)
    },
    forlistnewOBj (obj, parentId, code) {
      if (Object.keys(obj).length === 0) {
        obj[parentId] = code
      } else {
        for (let i in obj) {
          if (i === parentId) {
            obj[i] = code
          } else {
            obj[parentId] = code
          }
        }
      }
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/typescreen/index.vue